export const homeSliderTypes = {
    GET_HOME_SLIDERS: "GET_HOME_SLIDERS",
    CLEAR_HOME_INTRO: "CLEAR_HOME_INTRO",
};